import { render, staticRenderFns } from "./AdminLabels.vue?vue&type=template&id=7ec510ff"
import script from "./AdminLabels.vue?vue&type=script&lang=js"
export * from "./AdminLabels.vue?vue&type=script&lang=js"
import style0 from "./AdminLabels.vue?vue&type=style&index=0&id=7ec510ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports